import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface HumansOnlyState {
  /** When on, per-agent report rows hide AI agents (Ali, Bilal). Totals are unchanged. */
  humansOnly: boolean;
  setHumansOnly: (value: boolean) => void;
}

export const useHumansOnlyStore = create<HumansOnlyState>()(
  persist(
    (set) => ({
      humansOnly: false,
      setHumansOnly: (humansOnly) => set({ humansOnly }),
    }),
    {
      name: 'atlas.humansOnly',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ humansOnly: s.humansOnly }),
    },
  ),
);
